import React, { useEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import axios from "axios"
import DeleteIcon from '@material-ui/icons/Delete';


import { Button, IconButton, Snackbar } from "@material-ui/core"
import { ChevronLeft, ChevronRight, CardGiftcard, InfoOutlined, RateReviewOutlined } from "@material-ui/icons"
import { Rating } from '@material-ui/lab';


import Header from "./../ui/Header"
import Container from "./../ui/Container"
import BuyWidget from "./../ui/BuyWidget"
import FeedbackDialog from "./FeedbackDialog";

import DialogCall from "./../ui/DialogCall"

import {
    ExpandMore,
} from "@material-ui/icons"

import "./Product.css"


const AccordionHeader = ({ id, expanded, onToggle, children }) => (
    <h2 className="Product--section--heading">
        <button
            type="button"
            className="Product--section--toggle"
            aria-expanded={expanded}
            aria-controls={id}
            onClick={onToggle}
        >
            <span>{children}</span>
            <ExpandMore className={`Product--section--chevron${expanded ? " expanded" : ""}`} />
        </button>
    </h2>
)

const ProductCarousel = ({ picturesString, certificate, name, ua }) => {
    const [index, setIndex] = useState(0)
    const pictures = picturesString.split(",")

    const inc = () =>
        index < pictures.length - 1 ? setIndex(c => c + 1) : setIndex(0)
    const dec = () =>
        index > 0 ? setIndex(c => c - 1) : setIndex(pictures.length - 1)

    return (
        <div className={certificate ? "Product--carousel no-width" : "Product--carousel"}>
            <div className="Product--carousel--container">
                {pictures.map((picture, idx) => {
                    return (
                        <img
                            key={picture}
                            className={`Product--carousel--slide${idx === index ? " current" : ""}`}
                            src={process.env.REACT_APP_API + "/media/" + picture}
                            alt={name ? `${name} (${idx + 1}/${pictures.length})` : ""}
                        />
                    )
                })}
                {pictures.length > 1 && (
                    <div className="Product--carousel--controls">
                        <IconButton onClick={dec} aria-label={ua ? "Попереднє фото" : "Предыдущее фото"}>
                            <ChevronLeft />
                        </IconButton>
                        <IconButton onClick={inc} aria-label={ua ? "Наступне фото" : "Следующее фото"}>
                            <ChevronRight />
                        </IconButton>
                    </div>
                )}
            </div>
            {pictures.length > 1 && (
                <div className="Product--carousel--indicator">
                    {pictures.map((_, key) => {
                        return (
                            <button
                                type="button"
                                key={key}
                                onClick={() => setIndex(key)}
                                aria-label={`${key + 1} / ${pictures.length}`}
                                aria-current={index === key ? "true" : undefined}
                                className={`Product--carousel--dot${index === key ? " current" : ""}`}
                            ></button>
                        )
                    })}
                </div>
            )}
        </div>
    )
}

const Product = ({ match, translation, isLoggedIn, userId }) => {
    const [product, setProduct] = useState(null)
    const [snackBarOpen, setSnackBarOpen] = useState(false)
    const [showFeedbackDialog, setShowFeedbackDialog] = useState(false)
    const [messages, setMessages] = useState([])
    const [offset, setOffset] = useState(0)
    const [open, setOpen] = useState(false)
    const [expandedDes, setExpandedDes] = useState(false)
    const [expandedUsage, setExpandedUsage] = useState(false)
    const [expandedContent, setExpandedContent] = useState(false)
    const [expandedCertificate, setExpandedCertificate] = useState(false)

    // HACK
    const descriptionRef = useRef()
    const id = match.params.id

    useEffect(() => {
        axios(`/product/?id=${id}`).then(res => {
            setProduct(res.data)
        })
    }, [id])

    useEffect(() => {
        if (product) {
            if (expandedDes) {
                descriptionRef.current.innerHTML = translation.translateKey(
                    product,
                    "description"
                )
            } else descriptionRef.current.innerHTML = ""

        }
    }, [product, expandedDes, translation])


    useEffect(() => {
        axios(`/get_feedback/?product_id=${id}&offset=${offset}`).then(res => {
            console.log(res.data)
            setMessages(m => m.concat(res.data))
        })
    }, [id, offset])


    const sizeTypes = {
        1: "мл",
        2: "мг",
        3: "г",
        4: "шт"
    }

    const handleLoadMore = () => {
        setOffset(offset => offset + 1)
    }


    const handleDeleteFeedback = (feedbackId) => {
        let data = new FormData()

        data.append("feedback_id", feedbackId)

        axios.post("/delete_feedback/", data, { withCredentials: true }).then(res => {
            let updatedMsgs = messages.filter((msg) => msg.id !== res.data.id)
            setMessages(updatedMsgs)
        }).finally(setSnackBarOpen(false))
    }

    const handleExpandedUsage = () => {
        setExpandedUsage(!expandedUsage)
        // eslint-disable-next-line no-undef
        gtag('event', 'conversion', {
            'send_to': 'AW-659765647/EDiNCKuBz_gBEI_zzLoC',
            'event_callback': null
        });
    }

    const handleExpadedDes = () => {
        setExpandedDes(!expandedDes)
        // eslint-disable-next-line no-undef
        gtag('event', 'conversion', {
            'send_to': 'AW-659765647/EDiNCKuBz_gBEI_zzLoC',
            'event_callback': null
        });
    }

    const handleExpadedContent = () => {
        setExpandedContent(!expandedContent)
        // eslint-disable-next-line no-undef
        gtag('event', 'conversion', {
            'send_to': 'AW-659765647/EDiNCKuBz_gBEI_zzLoC',
            'event_callback': null
        });
    }

    const handleExpadedCertificate = () => {
        setExpandedCertificate(!expandedCertificate)
        // eslint-disable-next-line no-undef
        gtag('event', 'conversion', {
            'send_to': 'AW-659765647/EDiNCKuBz_gBEI_zzLoC',
            'event_callback': null
        });
    }

    const ua = translation.language === "ua"

    return (
        <div className="Product">
            <Header />
            <DialogCall pr={false} open={open} setOpen={setOpen} />
            <Container>
                <Snackbar
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left"
                    }}
                    open={snackBarOpen}
                    autoHideDuration={6000}
                    onClose={() => setSnackBarOpen(false)}
                    message="Товар добавлено в корзину"
                />
                {product && (
                    <div className="Product--page">
                        <div className="Product--lot">
                            <ProductCarousel picturesString={product.picture} name={translation.translateKey(product, "name")} ua={ua} />
                            <div className="Product--lot--info">
                                {product.firm_ua &&
                                    <p className="Product--firm">
                                        {translation.language === "ua" && "Виробник: "}
                                        {translation.language === "ru" && "Производитель: "}
                                        {translation.language === "ua" && product.firm_ua}
                                        {translation.language === "ru" && product.firm_ru}
                                    </p>
                                }
                                <h1>{translation.translateKey(product, "name")}</h1>
                                <div className="Product--price">
                                    {product.with_action === true ?
                                        <>
                                            <span className="new_price">{product.new_price.toLocaleString()} грн</span>
                                            <span className='sales_price'>
                                                <span className="visually-hidden">{ua ? "Стара ціна: " : "Старая цена: "}</span>
                                                {product.price.toLocaleString()} грн
                                            </span>
                                        </>
                                        : <span>{product.price.toLocaleString()} грн</span>
                                    }
                                </div>
                                <p className="Product--size">
                                    {product.size.toLocaleString()} {sizeTypes[product.size_type]}
                                    {product.additional_size !== 0 && <span> + </span>}
                                    {product.additional_size !== 0 && product.additional_size}
                                    {product.additional_size !== 0 && " " + sizeTypes[product.size_type]}
                                </p>
                                {product.is_gift &&
                                    <p className="Product--gift">
                                        <CardGiftcard />
                                        <span>
                                            {translation.language === "ua" && "Подарунок: "}
                                            {translation.language === "ru" && "Подарок: "}
                                            {translation.language === "ua" && product.gift_ua}
                                            {translation.language === "ru" && product.gift_ru}
                                        </span>
                                    </p>
                                }
                                <p className="Product--short">{translation.translateKey(product, "short")}</p>
                                <BuyWidget
                                    available={product.is_available}
                                    mode="column"
                                    product={product}
                                    onClick={() => setSnackBarOpen(true)}
                                />
                            </div>
                        </div>
                        <div className="Product--additional">
                            <div className="Product--section">
                                <AccordionHeader id="product-description" expanded={expandedDes} onToggle={handleExpadedDes}>
                                    {translation.language === "ua" && "Опис"}
                                    {translation.language === "ru" && "Описание"}
                                </AccordionHeader>
                                <div
                                    id="product-description"
                                    className="Product--section--body Product--description"
                                    ref={descriptionRef}
                                ></div>
                            </div>
                            <div className="Product--section">
                                <AccordionHeader id="product-usage" expanded={expandedUsage} onToggle={handleExpandedUsage}>
                                    {translation.language === "ua" && "Використання"}
                                    {translation.language === "ru" && "Использование"}
                                </AccordionHeader>
                                <div id="product-usage" className="Product--section--body">
                                    {expandedUsage && translation.translateKey(product, "instruction")}
                                </div>
                            </div>
                            <div className="Product--section">
                                <AccordionHeader id="product-components" expanded={expandedContent} onToggle={handleExpadedContent}>
                                    {translation.language === "ua" && "Склад"}
                                    {translation.language === "ru" && "Состав"}
                                </AccordionHeader>
                                <div id="product-components" className="Product--section--body">
                                    {expandedContent && translation.translateKey(product, "components")}
                                </div>
                            </div>
                            {product.certificates && (
                                <div className="Product--section">
                                    <AccordionHeader id="product-certificates" expanded={expandedCertificate} onToggle={handleExpadedCertificate}>
                                        {translation.language === "ua" && "Сертифікати"}
                                        {translation.language === "ru" && "Сертификаты"}
                                    </AccordionHeader>
                                    <div id="product-certificates" className="Product--section--body">
                                        {expandedCertificate && <ProductCarousel picturesString={product.certificates} certificate={true} ua={ua} />}
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                )}
                <div className="Product--additional--options">
                    {product && (
                        <BuyWidget
                            widgetProduct={true}
                            available={product.is_available}
                            mode="column"
                            product={product}
                            onClick={() => setSnackBarOpen(true)}
                        />
                    )
                    }
                    <Button
                        variant="outlined"
                        onClick={() => setOpen(true)}
                        color="primary"
                        size="large"
                        startIcon={<InfoOutlined />}
                        disableElevation
                    >
                        {translation.language === "ua" && "Отримати додакову інформацію"}
                        {translation.language === "ru" && "Получить дополнительную информацию"}
                    </Button>
                </div>
                <section className="Product--feedback" aria-labelledby="product-feedback-title">
                    <div className="Product--feedback-head">
                        <h2 className="Section--title" id="product-feedback-title">
                            {translation.language === "ua" && "Відгуки про товар"}
                            {translation.language === "ru" && "Отзывы о товаре"}
                        </h2>
                        <div className="Product--feedback-btn">
                            <Button
                                onClick={() => setShowFeedbackDialog(true)}
                                variant="contained"
                                color="primary"
                                startIcon={<RateReviewOutlined />}
                            >
                                <>
                                    {translation.language === "ua" && "Залишити відгук"}
                                    {translation.language === "ru" && "Оставить отзыв"}
                                </>

                            </Button>
                        </div>
                    </div>
                    {showFeedbackDialog && (
                        <FeedbackDialog
                            user={userId}
                            translation={translation}
                            onClose={() => setShowFeedbackDialog(false)}
                            product_id={product.id}
                            onSend={m => setMessages(ms => ms.concat(m))}
                        />
                    )}
                    <div className="Product--feedback-messages">
                        {messages.sort((a, b) => b.time - a.time).map(message => {
                            return (<article className="feedback-message" key={message.id}>
                                <div className="feedback-top">
                                    <div>
                                        <p className="feedback-author">{message.user_name}</p>
                                        <span className="feedback-date">{new Date(message.time * 1000).toLocaleDateString()}</span>
                                    </div>

                                    <Rating name="read-only" value={message.rate} readOnly size="small" />
                                </div>
                                <div className="feedback-bottom">
                                    <div className="feedback-text">
                                        <p>{message.text}</p>
                                    </div>
                                    {(userId.id === message.user_id ||
                                        (userId.id === 6 && userId.email === "vlad.yaromiy@gmail.com"))
                                        &&
                                        <div>
                                            <IconButton
                                                className="deleteForeverIcon"
                                                onClick={() => handleDeleteFeedback(message.id)}
                                                aria-label={ua ? "Видалити відгук" : "Удалить отзыв"}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </div>}
                                </div>
                            </article>)
                        })}
                    </div>
                    {messages.length !== 0 && <Button
                        className={"feedback--load"}
                        variant="outlined"
                        color="primary"
                        onClick={handleLoadMore}
                    >
                        {translation.language === "ua" && "Завантажити ще"}
                        {translation.language === "ru" && "Загрузить еще"}
                    </Button>}

                </section>
            </Container>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        translation: state.translationReducer,
        isLoggedIn: state.sessionReducer.isLoggedIn,
        userId: state.sessionReducer.user
    }
}

export default connect(mapStateToProps, null)(Product)
